import L from "leaflet";

export function makeNumberedIcon(color, n) {
  return L.divIcon({
    className: "",
    html: `<div style="background:${color};color:#fff;border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.3);border-radius:9999px;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:12px;font-family:Outfit,sans-serif">${n}</div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });
}

export function depositoIcon() {
  return L.divIcon({
    className: "",
    html: `<div style="background:#0F172A;color:#fff;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.4);border-radius:6px;width:32px;height:32px;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:16px;font-family:Outfit,sans-serif">⌂</div>`,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
  });
}
